<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-ci-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-ci-badge">Check In</span>

  <div class="cr-ci-row">
    <div
      class="cr-ci-dropzone"
      [appInlineMedia]="block.variables?.['CheckInImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'CheckInImage')"
    >
      <a *ngIf="block.variables?.['CheckInImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['CheckInImage']" [alt]="block.variables?.['CheckInImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-ci-content">
      <span
        class="cr-ci-heading"
        [appInlineEdit]="block.variables?.CheckInHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'CheckInHeading')"
      ></span>

      <span
        class="cr-ci-text"
        [appInlineEdit]="block.variables?.CheckInText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'CheckInText')"
      ></span>

      <a class="cr-ci-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.CheckInCtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'CheckInCtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-ci-edit" *ngIf="!isPreview">
  <div class="cr-ci-field-row">
    <span class="cr-ci-field-label">Image</span>
    <span
      class="cr-ci-toggle"
      [class.cr-ci-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-ci-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['CheckInImage'] ?? ''"
      (handleOnChange)="onChange($event, 'CheckInImage')"
      [placeholder]="imagePlaceholder"
      variable="CheckInImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-ci-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['CheckInImage']">
      <div class="cr-ci-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-ci-title">Upload image</div>
      <div class="cr-ci-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-ci-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['CheckInImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'CheckInImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="CheckInImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'CheckInImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['CheckInImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['CheckInImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'CheckInImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="CheckInImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['CheckInHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'CheckInHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="CheckInHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['CheckInText'] ?? ''"
    (handleOnChange)="onChange($event, 'CheckInText')"
    [placeholder]="textPlaceholder"
    [maxLength]="500"
    variable="CheckInText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-ci-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['CheckInCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'CheckInCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="CheckInCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'CheckInCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['CheckInCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['CheckInCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'CheckInCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="CheckInCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
